import { Component, EventEmitter, Input, Output } from "@angular/core";
import { generate, observe } from "fast-json-patch";
import { ToastrService } from "ngx-toastr";
import { mergeMap, tap } from "rxjs";
import { AuthenticationService } from "../../../core/core";
import { ActivityService } from "../../services/activity.service";
import { ActivityTypeBaseComponent } from "../activity-type-base/activity-type-base.component";

@Component({
  selector: "common-activity-file-upload",
  templateUrl: "./activity-file-upload.component.html",
  styleUrls: ["./activity-file-upload.component.scss"],
})
export class ActivityFileUploadComponent extends ActivityTypeBaseComponent {
  file: File;
  fileName: string;
  blobUrl: string;

  @Output() fileUploaded = new EventEmitter<boolean>();

  constructor(activityService: ActivityService, authService: AuthenticationService, toastr: ToastrService) {
    super(activityService, authService, toastr);
  }

  ngOnInit(): void {
    super.ngOnInit();

    if (this.activity.storageModels?.length > 0 && this.activity.storageModel == null) {
      this.activity.storageModel = this.activity.storageModels[0];
    }

    if (this.activity.storageModel) {
      const parts = this.activity.storageModel.storagePath.split("/");
      this.fileName = parts[parts.length - 1]; // Or parts.pop();
      this.blobUrl = this.environment.baseImagePath + "/" + this.activity.storageModel.storagePath;
    }
  }

  onFileSelected(file: File) {
    this.file = file;
    this.upload();
  }

  upload() {
    this.activityService
      .uploadFile(this.activity, this.file)
      .pipe(
        mergeMap(result => {
          const observer = observe(this.activity);
          this.activity.status = this.activity.requiresAdminApproval ? "PendingReview" : "Closed";
          this.activity.completedDateTime = new Date().toDateString();
          this.activity.completedByUserId = this.user.profile.sub;

          const jsonPatch = generate(observer);
          this.activity.storageModel = result;
          return this.activityService.jsonPatchWithPartitionKey(this.activity.id, jsonPatch, this.activity.accountId);
        }),
        tap(result => {
          this.toastr.success("File uploaded.");
          this.fileUploaded.emit(true);
          this.ngOnInit();
        }),
      )
      .subscribe();
  }

  delete() {
    if (!confirm(`Are you sure you want to delete ${this.fileName}? This will set the task back to open.`)) {
      return;
    }

    this.activity.status = "Open";
    this.activity.storageModel = null;
    this.activity.completedDateTime = null;

    // for some reason the observer was not wiping out storage model
    const jsonPatch = [
      { op: "replace", path: "/completedDateTime", value: null },
      { op: "replace", path: "/storageModel", value: null },
      { op: "replace", path: "/storageModels", value: [] },
      { op: "replace", path: "/status", value: "Open" },
    ];
    this.activityService.jsonPatchWithPartitionKey(this.activity.id, jsonPatch, this.activity.accountId).subscribe(result => {
      this.toastr.success("File deleted.");
      this.file = null;
      this.fileUploaded.emit(false);
    });
  }
}
